// testModule.js
// Kế thừa lại các class gốc và chỉ thêm log (không thay đổi logic chính)
// File được tự động load thông qua require.context trong main.js

// Đảm bảo các class base đã được expose
const { Boot: BootBase, libraryMJ: LibraryMJBase, Core: CoreBase } = window.__LibraryBase || {};
if (!BootBase || !LibraryMJBase || !CoreBase) {
  console.warn('[testModule] Base classes chưa sẵn sàng');
}

class BootExtend extends BootBase {
  // Ví dụ hàm kế thừa
  getElementsDevice() {
    super.getElementsDevice();
  }
  // Ví dụ tạo hàm mới
  newFunction() {
    super.getElementsDevice();
  }

  // Chỗ này là để gọi lại
  async run() {
    super.run();
    this.newFunction();
  };
}

class LibraryMJExtend extends LibraryMJBase {

  // Chỗ này là để gọi lại
  async run() {
    super.run();
  };
}

// Chỗ này được thì khỏi đụng vào nếu ko cần thiết
class CoreExtend extends CoreBase {
  constructor() {
    super();
  }
  async init() {
    await Promise.all([
      (new BootExtend()).run(),
      (new LibraryMJExtend()).run()
    ]);
  }
}

// Khởi tạo phiên bản riêng (không ghi đè libraryMainsite gốc)
// const libraryMainsiteTest = new CoreExtend();
// window.libraryMainsite = libraryMainsiteTest;
